import * as React from "react";
import { Typography, IconButton, Tooltip, Avatar, Divider } from "../mui";
import { 
  CloseRoundedIcon, 
  KeyboardDoubleArrowLeftRoundedIcon, 
  KeyboardDoubleArrowRightRoundedIcon,
  SettingsRoundedIcon,
  LogoutRoundedIcon
} from "../icons";

import logoStaystrack from "../../images/logo-staystrack.svg";
import avatarImage from "../../images/img-avatar.jpg";
import { MENU_ITEMS } from "./menuItems";

export default function Sidebar({ menuItems = MENU_ITEMS, activeKey = "dashboard", onNavigate, isOpen = false, onClose, isCollapsed = false, onToggleCollapse, onLogout }) {
  return (
    <>
      {isOpen && <div className="app-sidebar-overlay" onClick={onClose} />}
      <aside className={`app-sidebar ${isOpen ? 'is-open' : ''} ${isCollapsed ? 'is-collapsed' : ''}`}>
      <div className="app-sidebar-header">
        <div className="app-sidebar-brand">
          <div className="app-sidebar-brand-avatar">
            <img
              src={logoStaystrack}
              alt="StaysTrack logo"
              className="app-sidebar-brand-avatar-image"
            />
          </div>
          <div>
            <Typography variant="h6" className="app-sidebar-brand-title">
              StaysTrack
            </Typography>
          </div>
        </div>
        <IconButton 
          className="app-sidebar-toggle"
          onClick={onToggleCollapse}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? <KeyboardDoubleArrowRightRoundedIcon /> : <KeyboardDoubleArrowLeftRoundedIcon />}
        </IconButton>
      </div>

      <nav className="app-sidebar-nav" aria-label="Primary">
        {menuItems.map((item) => {
          const ItemIcon = item.icon;
          const className = `app-sidebar-nav-item ${item.key === activeKey ? "is-active" : ""}`.trim();
          const handleClick = () => {
            if (typeof onNavigate === "function") {
              onNavigate(item);
              return;
            }

            if (item.href) {
              window.location.assign(item.href);
            }
          };

          const buttonContent = (
            <button key={item.key || item.label} type="button" className={className} onClick={handleClick}>
              {ItemIcon ? <ItemIcon className="app-sidebar-nav-icon" /> : null}
              <span className="app-sidebar-nav-label">{item.label}</span>
            </button>
          );

          return isCollapsed ? (
            <Tooltip 
              key={item.key || item.label}
              title={item.label} 
              placement="right"
              arrow
            >
              {buttonContent}
            </Tooltip>
          ) : buttonContent;
        })}
      </nav>

      {/* User Profile Section */}
      <div className="app-sidebar-footer">
        <Divider className="app-sidebar-divider" />
        
        {/* User Profile */}
        <div className="app-sidebar-user">
          <Avatar 
            className="app-sidebar-user-avatar"
            src={avatarImage}
            alt="Angelica Santos"
            sx={{ 
              width: isCollapsed ? 32 : 40,
              height: isCollapsed ? 32 : 40
            }}
          />
          {!isCollapsed && (
            <div className="app-sidebar-user-info">
              <Typography variant="body2" className="app-sidebar-user-name">
                Angelica Santos
              </Typography>
              <Typography variant="caption" className="app-sidebar-user-role">
                EMP-12345
              </Typography>
            </div>
          )}
        </div>

        {/* Settings & Logout */}
        <div className="app-sidebar-actions">
          <Tooltip title={isCollapsed ? "Settings" : ""} placement="right" arrow={isCollapsed}>
            <button 
              className="app-sidebar-action-btn"
              type="button"
              onClick={() => onNavigate && onNavigate({ key: "settings" })}
            >
              <SettingsRoundedIcon className="app-sidebar-action-icon" />
              {!isCollapsed && <span className="app-sidebar-action-label">Settings</span>}
            </button>
          </Tooltip>
          
          <Tooltip title={isCollapsed ? "Logout" : ""} placement="right" arrow={isCollapsed}>
            <button 
              className="app-sidebar-action-btn"
              type="button"
              onClick={onLogout}
            >
              <LogoutRoundedIcon className="app-sidebar-action-icon" />
              {!isCollapsed && <span className="app-sidebar-action-label">Logout</span>}
            </button>
          </Tooltip>
        </div>
      </div>
    </aside>
    </>
  );
}
